import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Row,
  Button,
  Col,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
} from "reactstrap";
import "./index.css";
import CustomDropdownInput from "../CustomDropdownInput";
import CustomTextInput from "../CustomTextInput";
import ApiCaller from "../../api/apiCaller";
import CustomAlert from "../CustomAlert";

interface SiteConversationModalProps {
  siteId: number;
  isShowModal: boolean;
  setIsShowModal: Function;
  setConversations: Function;
}

export default function SiteConversationModal({
  siteId,
  isShowModal,
  setIsShowModal,
  setConversations,
}: SiteConversationModalProps) {
  const [conversation, setConversation] = useState<any>({
    user_name: null,
    contact_channel: null,
    contact: null,
    contact_date: null,
    message: null,
  });

  const [alertData, setAlertData] = useState({
    isShow: false,
    content: "",
    color: "danger",
  });

  const [contactOptions, setContactOptions] = useState([]);

  const [contactChannelOptions, setContactChannelOptions] = useState([
    {
      value: "Gọi điện thoại",
      label: "Gọi điện thoại",
    },
    {
      value: "Gọi qua Viber/Zalo/etc",
      label: "Gọi qua Viber/Zalo/etc",
    },
    {
      value: "Gửi email",
      label: "Gửi email",
    },
    {
      value: "Gặp trực tiếp",
      label: "Gặp trực tiếpi",
    },
  ]);

  const getInitData = async () => {
    if (!siteId) return;
    const [resLabels, resContactOptions] = await Promise.all([
      ApiCaller.get("site_conversation/_labels"),
      ApiCaller.get(
        `site_contact/?q=(filters:!((col:is_active,opr:eq,value:1),(col:site,opr:rel_o_m,value:${siteId})))`
      ),
    ]);
    if (resLabels?.status === "ok") {
      setLabels(resLabels?.labels);
    }
    if (resContactOptions.result) {
      setContactOptions(
        resContactOptions?.result?.map((item: any) => {
          return {
            value: item?.contact?.id,
            label: `${item?.contact?.last_name || ""} ${
              item?.contact?.middle_name || ""
            } ${item?.contact?.first_name || ""}`,
          };
        })
      );
    }
  };

  useEffect(() => {
    getInitData();
  }, []);

  const [labels, setLabels] = useState({});

  const updateAttr = (attribute: string, value: any) => {
    let dataUpdate = {};
    if (value?.label) {
      // Check value is object (value from dropdown menu)
      dataUpdate = {
        [attribute]: {
          id: value?.value,
          name: value?.label,
        },
      };
    } else {
      dataUpdate = { [attribute]: value };
    }
    setConversation({
      ...conversation,
      ...dataUpdate,
    });
  };

  const createNewConversation = async () => {
    let createData = {
      ...conversation,
      ...{
        contact_channel: conversation?.contact_channel?.name,
        site: { id: siteId },
      },
    };
    if (!createData?.contact || !createData?.contact_channel || !createData?.contact_date || !createData?.message) {
      setAlertData({
        ...alertData,
        ...{ content: "Bạn cần phải điền đầy đủ thông tin", isShow: true },
      });
      return
    }
    const res = await ApiCaller.post("site_conversation/", createData);
    if (res?.result) {
      const resListConversations = await ApiCaller.get(
        `site_conversation/list?site_id=${siteId}`
      );
      if (resListConversations?.status === "ok") {
        setConversations(resListConversations?.result);
      }
    }
    setAlertData({
      ...alertData,
      ...{ isShow: false },
    });
    setIsShowModal(false);
  };

  const uiLayoutDefinition: any = [
    {
      type: "row",
      label: "Khu vực xung quanh",
      items: [
        {
          attributeName: "user_name",
          type: "text",
          size: 6,
        },
        {
          attributeName: "contact",
          type: "dropdown",
          size: 6,
          options: contactOptions,
        },
        {
          attributeName: "contact_channel",
          type: "dropdown",
          size: 6,
          options: contactChannelOptions,
        },
        { attributeName: "contact_date", type: "date", size: 6 },
        { attributeName: "message", type: "textarea", size: 12 },
      ],
    },
  ];

  if (Object.keys(labels).length == 0) return null;

  return (
    <Modal
      isOpen={isShowModal}
      size="lg"
      centered
      toggle={() => {
        setAlertData({
          ...alertData,
          ...{ isShow: false },
        });
        setIsShowModal(false);
      }}
    >
      <ModalHeader
        toggle={() => {
          setAlertData({
            ...alertData,
            ...{ isShow: false },
          });
          setIsShowModal(false);
        }}
      >
        Thêm cập nhật
      </ModalHeader>
      <ModalBody>
        <CustomAlert
          {...{
            content: alertData.content,
            isShow: alertData.isShow,
            color: alertData.color,
          }}
        />
        {uiLayoutDefinition.map((row: any, index: number) => (
          <Row key={index}>
            {row.items.map((layoutItem: any) => {
              if (layoutItem.type === "dropdown") {
                return (
                  <Col sm={{ size: layoutItem.size, offset: 0 }}>
                    <CustomDropdownInput
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={conversation}
                      options={layoutItem.options}
                      labels={labels}
                      attributeName={layoutItem.attributeName}
                    />
                  </Col>
                );
              } else if (
                layoutItem.type === "text" ||
                layoutItem.type === "textarea" ||
                layoutItem.type === "date"
              ) {
                return (
                  <Col sm={{ size: layoutItem.size, offset: 0 }}>
                    <CustomTextInput
                      type={layoutItem.type}
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={conversation}
                      labels={labels}
                      attributeName={layoutItem.attributeName}
                    />
                  </Col>
                );
              } else if (layoutItem.type === "break") {
                return <Col sm={{ size: 4, offset: 0 }} />;
              } else if (layoutItem.type === "custom") {
                return (
                  <Col sm={{ size: layoutItem.size, offset: 0 }}>
                    {layoutItem.component}
                  </Col>
                );
              }
            })}
          </Row>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            createNewConversation();
            // setIsShowModal(false);
          }}
        >
          Lưu
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() => {
            setAlertData({
              ...alertData,
              ...{ isShow: false },
            });
            setIsShowModal(false);
          }}
        >
          Hủy
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
};
